"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchGTMEvent = function (event, dataLayerName) {
    if (dataLayerName === void 0) { dataLayerName = 'dataLayer'; }
    if (typeof window !== 'undefined' && window[dataLayerName]) {
        window[dataLayerName].push(event);
    }
    else {
        // eslint-disable-next-line no-console
        console.warn('[GTM] No datalayer!');
    }
};
exports.default = exports.dispatchGTMEvent;
//# sourceMappingURL=dispatchGTMEvent.js.map